"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _components = require("components");

var _punjabLogo = require("egov-ui-kit/assets/images/punjab-logo.png");

var _punjabLogo2 = _interopRequireDefault(_punjabLogo);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner = function Banner(_ref) {
  var children = _ref.children,
      hideBackButton = _ref.hideBackButton,
      history = _ref.history,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      logoUrl = _ref.logoUrl,
      bannerUrl = _ref.bannerUrl;

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: className + " user-screens-wrapper" },
      _react2.default.createElement(
        "div",
        { className: "banner-image", style: bannerUrl && { backgroundImage: "url(" + bannerUrl + ")" } },
        _react2.default.createElement("div", { className: "banner-overlay" }),
        _react2.default.createElement(
          "div",
          { className: "banner-main-content" },
          !hideBackButton && _react2.default.createElement(_components.Icon, { onClick: function onClick() {
              return history.goBack();
            }, className: "banner-back-button", action: "navigation", name: "arrow-back" }),
          _react2.default.createElement(
            "div",
            { className: "banner-form-cont" },
            children
          )
        )
      )
    )
  );
};

exports.default = (0, _reactRouter.withRouter)(Banner);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/Banner/index.js
// module id = ../lib/egov-ui-kit/common/common/Banner/index.js
// module chunks = 504